import React, { Component } from 'react'

var ES6Promise = require('es6-promise')
ES6Promise.polyfill()

export class GenericErrorPage extends Component {
  render () {
    return (
      <div className='content content-error grid-content-full'>
        <h1 className="section-header">Sorry, an error has occurred</h1>
        <p>An error has occurred, and we are unable to complete your request.</p>
        <p>Please click the button to try again.  If the error persists, please <a className='hyperLink' href='/#/help'>contact Customer Services</a> for assistance.</p>
        <div className='inner-container'>
          <a className='pure-button primary-action margin-left-0' href='#' onClick={event => window.history.back()} target='_self'>
            Retry
          </a>
        </div>
      </div>
    )
  }
}

export default GenericErrorPage
